import styled from "styled-components";
import media from "../../../../styles/media";

const ResponsiveImg = styled.div`
	width: 100%;
	height: 100%;
	overflow: hidden;
	position: relative;
	img {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		object-fit: cover;
	}
`;

const HomePageFeatureSliderContainer = styled.div`
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	margin-bottom: 2rem;
	.banners {
		border-radius: 6px;
		width: 83%;
		height: 300px;
		${media.greaterThan("huge")`
			height: 360px;
		`}
		.swiper-container {
			height: 300px;
			${media.greaterThan("huge")`
				height: 360px;
			`}
			${media.lessThan("medium")`
				height: 170px;
			`}
		}
		${media.lessThan("medium")`
			height: 170px;
			border-radius: 6px 6px 0 0;
		`}
	}
	.thumbs {
		width: 15%;
		height: 300px;
		border-radius: 6px;
		${media.lessThan("medium")`
			height: 70px;
			border-radius: 0 0 6px 6px;
		`}
		${media.greaterThan("huge")`
			height: 360px;
		`}
		.swiper-container {
			height: 300px;
			${media.lessThan("medium")`
				height: 70px;
			`}
			${media.greaterThan("huge")`
				height: 360px;
			`}
		}
		${ResponsiveImg} {
			transition: 0.3s ease;
			border-radius: 4px;
			overflow: hidden;
			&:hover {
				opacity: 0.8;
				transform: scale(1.02);
			}
			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				${media.lessThan("medium")`
					height: 60px;
				`}
			}
		}
		.swiper-slide {
			position: relative;
			&:before {
				position: absolute;
				top: 0;
				left: 0;
				height: 100%;
				width: 100%;
				content: "";
				display: block;
				z-index: 999;
				border: 2px solid transparent;
				border-radius: 4px;
				transition: 0.3s ease;
				cursor: pointer;
				box-sizing: border-box;
			}
			&:hover {
				&:before {
					border: 2px solid ${(props) => props.theme.color.primary};
				}
			}
		}
		.swiper-slide-thumb-active {
			${ResponsiveImg} {
				opacity: 1;
			}
			&:before {
				border: 2px solid ${(props) => props.theme.color.primary};
				box-shadow: 0 0 8px rgba(1, 68, 145, 0.3);
			}
		}
	}
	.banners,
	.thumbs {
		overflow: hidden;
		${media.lessThan("medium")`
			width: 100% !important;
		`}
	}
`;

const BannerInfoArea = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	padding: 20px;
	width: 100%;
	height: 100%;
	background: linear-gradient(to top, rgba(0, 0, 0, 0.6) 5%, rgba(0, 0, 0, 0) 90%);
	color: #fff;
	.infos {
		width: 100%;
		position: absolute;
		bottom: 20px;
		left: 20px;
	}
	.bannerTitle,
	.bannerSubtitle {
		display: block;
	}
	.bannerTitle {
		font-size: 2em;
	}
`;

export { HomePageFeatureSliderContainer, ResponsiveImg, BannerInfoArea };
